import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_f2c4f8f0";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_f2c4f8f0" };
/** script content **/
require("./tip.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findexf2c4f8f0%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ftip%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_f2c4f8f0"],
    ctorType: "component",
    outputPath: "components/indexf2c4f8f0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-icon': getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
